module.exports = __webpack_public_path__ + "static/media/default_profile_img.f6e8b017.png";